import React, { Component } from "react";
import { connect } from "react-redux";
import { setAgeRange, toggleView } from "../actions";
import Summary from "./Summary";
import NavigationMenu from "./NavigationMenu";
import HotKeys from "./HotKeys";
import "../styles/AgeForm.css";
import track from "../lib/tracking"

const mapStateToProps = (state, ownProps) => {
  return {
    ageRange: state.ageRange
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setAgeRange: range => {
      dispatch(setAgeRange(range));
    },
    prevPage: () => dispatch(toggleView("target")),
    nextPage: () => dispatch(toggleView("results"))
  };
};

class AgeFormContainer extends Component {
  handleChange(value, t, i) {
    const ageRange = this.props.ageRange.slice();
    ageRange[i][t] = parseInt(value, 10);
    this.props.setAgeRange(ageRange);
  }

  newInterval = (e) => {
    const ageRange = this.props.ageRange.slice();
    ageRange[ageRange.length] = {
      min: ageRange[ageRange.length - 1].max,
      max: 65
    };
    this.props.setAgeRange(ageRange);
    this.ageRefs[this.ageRefs.length-1].focus();
    this.ageRefs[this.ageRefs.length-1].select();
    track("age_added",{ageRange})

  }

  deleteInterval(index) {
    const ageRange = this.props.ageRange.slice();
    ageRange.splice(index, 1);
    this.props.setAgeRange(ageRange);
  }

  ageRefs = [];
  prevPage = (e,focus) => {
    if(focus && focus.tagName === "INPUT"){
      return;
    }
    this.props.prevPage();
  }
  nextPage = (e,focus) => {
    if(focus && focus.tagName === "INPUT"){
      return;
    }
    this.props.nextPage();
  }

  render() {
    const ageList = this.props.ageRange.map((value, index) => {
      return (
        <div className="age-range__wrapper" key={value + "-" + index}>
          <div className="age-range" key={"ageRange-" + index}>
            <input
              type="number"
              className="input input--number"
              value={value.min}
              onChange={e => this.handleChange(e.target.value, "min", index)}
            />
            -
            <input
              type="number"
              className="input input--number"
              value={value.max}
              ref={ (ref) => this.ageRefs.push(ref) }
              onChange={e => this.handleChange(e.target.value, "max", index)}
            />
          </div>
          {index > 0 &&
            <a
              className="button--circular"
              onClick={e => this.deleteInterval(index)}
            >
              <i className="fa fa-times" />
            </a>}
        </div>
      );
    });

    const keyMap = {
      addNew: "enter",
      nextPage: "arrowright",
      prevPage: "arrowleft",
    };

    const handlers = {
      addNew: this.newInterval,
      nextPage: this.nextPage,
      prevPage: this.prevPage,
    };

    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className="column">
          <h1 className="title">Audience Age</h1>
          <h2 className="sub-title">
            Add as many age ranges as you want by clicking the plus button.
          </h2>
          <div className="column__section">

            <div className="ages">
              <label>From<span />To</label>
              {ageList}
              <a className="button--circular" onClick={e => this.newInterval(e)}>
                <i className="fa fa-plus" />
              </a>
            </div>
          </div>

          <hr className="separator" />

          <NavigationMenu prev="target" next="results" />
          <Summary />
        </div>
      </HotKeys>
    );
  }
}

const AgeForm = connect(mapStateToProps, mapDispatchToProps)(AgeFormContainer);

export default AgeForm;



// WEBPACK FOOTER //
// ./src/components/AgeForm.js